export const GET_PATIENTS_CHART = 'chartsPage/GET_PATIENTS_CHART'
export const GET_PATIENTS_CHART_SUCCESS = 'chartsPage/GET_PATIENTS_CHART_SUCCESS'
export const GET_PATIENTS_CHART_ERROR = 'chartsPage/GET_PATIENTS_CHART_ERROR'

export const GET_PATIENTS_LIST = 'chartsPage/GET_PATIENTS_LIST'
export const GET_PATIENTS_LIST_SUCCESS = 'chartsPage/GET_PATIENTS_SUCCESS'
export const GET_PATIENTS_LIST_ERROR = 'chartsPage/GET_PATIENTS_ERROR'

export const GET_ALERTS = 'chartsPage/GET_ALERTS'
export const GET_ALERTS_SUCCESS = 'chartsPage/GET_ALERTS_SUCCESS'
export const GET_ALERTS_ERROR = 'chartsPage/GET_ALERTS_ERROR'

export const GET_PRESCRIPTIONS = 'chartsPage/GET_PRESCRIPTIONS'
export const GET_PRESCRIPTIONS_SUCCESS = 'chartsPage/GET_PRESCRIPTIONS_SUCCESS'
export const GET_PRESCRIPTIONS_ERROR = 'chartsPage/GET_PRESCRIPTIONS_ERROR'

export const GET_PATIENT_TREAT_LINK = 'chartPage/GET_PATIENT_TREAT_LINK'
export const GET_PATIENT_TREAT_LINK_SUCCESS = 'chartPage/GET_PATIENT_TREAT_LINK_SUCCESS'
export const GET_PATIENT_TREAT_LINK_ERROR = 'chartPage/GET_PATIENT_TREAT_LINK_ERROR'

export const GET_PATIENT_PAST_VISITS = 'chartPage/GET_PATIENT_PAST_VISITS'
export const GET_PATIENT_PAST_VISITS_SUCCESS = 'chartPage/GET_PATIENT_PAST_VISITS_SUCCESS'
export const GET_PATIENT_PAST_VISITS_ERROR = 'chartPage/GET_PATIENT_PAST_VISITS_ERROR'

export const GET_PATIENT_UPCOMING_VISITS = 'chartPage/GET_PATIENT_UPCOMING_VISITS'
export const GET_PATIENT_UPCOMING_VISITS_SUCCESS = 'chartPage/GET_PATIENT_UPCOMING_VISITS_SUCCESS'
export const GET_PATIENT_UPCOMING_VISITS_ERROR = 'chartPage/GET_PATIENT_UPCOMING_VISITS_ERROR'

export const GET_PATIENT_INTAKE_FORMS = 'chartPage/GET_PATIENT_INTAKE_FORMS'
export const GET_PATIENT_INTAKE_FORMS_SUCCESS = 'chartPage/GET_PATIENT_INTAKE_FORMS_SUCCESS'
export const GET_PATIENT_INTAKE_FORMS_ERROR = 'chartPage/GET_PATIENT_INTAKE_FORMS_ERROR'

export const GET_PAST_VISIT_INFO = 'chartPage/GET_PAST_VISIT_INFO'
export const GET_PAST_VISIT_INFO_SILENCE = 'chartPage/GET_PAST_VISIT_INFO_SILENCE'
export const GET_PAST_VISIT_INFO_SUCCESS = 'chartPage/GET_PAST_VISIT_INFO_SUCCESS'
export const GET_PAST_VISIT_INFO_ERROR = 'chartPage/GET_PAST_VISIT_INFO_ERROR'

export const GET_PAST_VISIT_TREAT_LINK = 'chartPage/GET_PAST_VISIT_TREAT_LINK'
export const GET_PAST_VISIT_TREAT_LINK_SUCCESS = 'chartPage/GET_PAST_VISIT_TREAT_LINK_SUCCESS'
export const GET_PAST_VISIT_TREAT_LINK_ERROR = 'chartPage/GET_PAST_VISIT_TREAT_LINK_ERROR'

export const GET_INTAKE_FORM = 'chartPage/GET_INTAKE_FORM'
export const GET_INTAKE_FORM_SUCCESS = 'chartPage/GET_INTAKE_FORM_SUCCESS'
export const GET_INTAKE_FORM_ERROR = 'chartPage/GET_INTAKE_FORM_ERROR'

export const ADD_ALERT = 'chartsPage/ADD_ALERT'
export const ADD_ALERT_SUCCESS = 'chartsPage/ADD_ALERT_SUCCESS'
export const ADD_ALERT_ERROR = 'chartsPage/ADD_ALERT_ERROR'

export const ADD_PATIENT_ALLERGY = 'chartsPage/ADD_PATIENT_ALLERGY'
export const ADD_PATIENT_ALLERGY_SUCCESS = 'chartsPage/ADD_PATIENT_ALLERGY_SUCCESS'
export const ADD_PATIENT_ALLERGY_ERROR = 'chartsPage/ADD_PATIENT_ALLERGY_ERROR'

export const DELETE_ALERT = 'chartsPage/DELETE_ALERT'
export const DELETE_ALERT_SUCCESS = 'chartsPage/DELETE_ALERT_SUCCESS'
export const DELETE_ALERT_ERROR = 'chartsPage/DELETE_ALERT_ERROR'

export const DELETE_PATIENT_ALLERGY = 'chartsPage/DELETE_PATIENT_ALLERGY'
export const DELETE_PATIENT_ALLERGY_SUCCESS = 'chartsPage/DELETE_PATIENT_ALLERGY_SUCCESS'
export const DELETE_PATIENT_ALLERGY_ERROR = 'chartsPage/DELETE_PATIENT_ALLERGY_ERROR'

export const EDIT_ALERT = 'chartsPage/EDIT_ALERT'
export const EDIT_ALERT_SUCCESS = 'chartsPage/EDIT_ALERT_SUCCESS'
export const EDIT_ALERT_ERROR = 'chartsPage/EDIT_ALERT_ERROR'

export const MARK_ALL_USER_ALERTS_AS_READ = 'chartPage/MARK_ALL_USER_ALERTS_AS_READ'
export const MARK_ALL_USER_ALERTS_AS_READ_SUCCESS = 'chartPage/MARK_ALL_USER_ALERTS_AS_READ_SUCCESS'
export const MARK_ALL_USER_ALERTS_AS_READ_ERROR = 'chartPage/MARK_ALL_USER_ALERTS_AS_READ_ERROR'

export const SAVE_GENERAL_INFO = 'chartPage/SAVE_GENERAL_INFO'
export const SAVE_GENERAL_INFO_SUCCESS = 'chartPage/SAVE_GENERAL_INFO_SUCCESS'
export const SAVE_GENERAL_INFO_ERROR = 'chartPage/SAVE_GENERAL_INFO_ERROR'

export const SAVE_ACCOUNT_INFO = 'chartPage/SAVE_ACCOUNT_INFO'
export const SAVE_ACCOUNT_INFO_SUCCESS = 'chartPage/SAVE_ACCOUNT_INFO_SUCCESS'
export const SAVE_ACCOUNT_INFO_ERROR = 'chartPage/SAVE_ACCOUNT_INFO_ERROR'

export const CHECK_PHONE = 'chartPage/CHECK_PHONE'
export const CHECK_PHONE_SUCCESS = 'chartPage/CHECK_PHONE_SUCCESS'
export const CHECK_PHONE_ERROR = 'chartPage/CHECK_PHONE_ERROR'

export const COMPLETE_VISIT = 'chartPage/COMPLETE_VISIT'
export const COMPLETE_VISIT_SUCCESS = 'chartPage/COMPLETE_VISIT_SUCCESS'
export const COMPLETE_VISIT_ERROR = 'chartPage/COMPLETE_VISIT_ERROR'

export const UNRESOLVE_VISIT = 'chartPage/UNRESOLVE_VISIT'
export const UNRESOLVE_VISIT_SUCCESS = 'chartPage/UNRESOLVE_VISIT_SUCCESS'
export const UNRESOLVE_VISIT_ERROR = 'chartPage/UNRESOLVE_VISIT_ERROR'

export const SEARCH_PHARMACIES = 'chartPage/SEARCH_PHARMACIES'
export const SEARCH_PHARMACIES_SUCCESS = 'chartPage/SEARCH_PHARMACIES_SUCCESS'
export const SEARCH_PHARMACIES_ERROR = 'chartPage/SEARCH_PHARMACIES_ERROR'

export const SET_PATIENT_ID = 'chartPage/SET_PATIENT_ID'
export const SET_ALLERGY_NAME_ERROR = 'chartsPage/SET_ALLERGY_NAME_ERROR'
export const SET_IS_CHANGED_VISIT_STATUS_SUCCESS = 'chartsPage/SET_IS_CHANGED_VISIT_STATUS_SUCCESS'
export const SET_ALLERGY_SEVERITY_ERROR = 'chartsPage/SET_ALLERGY_SEVERITY_ERROR'
export const SET_PAST_VISIT_TREAT_LINK = 'chartsPage/SET_PAST_VISIT_TREAT_LINK'
export const SET_IS_PHONE_CORRECT = 'chartsPage/SET_IS_PHONE_CORRECT'
export const SET_IS_PHARMACY_SEARCHING_DONE = 'chartsPage/SET_IS_PHARMACY_SEARCHING_DONE'
export const SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS = 'chartsPage/SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS'
export const SET_PATIENT_ID_FOR_RESET_MEDIA_FILES = 'chartsPage/SET_PATIENT_ID_FOR_RESET_MEDIA_FILES'
export const SET_IS_NEED_TO_UPDATE_PAST_VISITS = 'chartsPage/SET_IS_NEED_TO_UPDATE_PAST_VISITS'
export const SET_UPCOMING_VISIT_NOTE = 'chartsPage/SET_UPCOMING_VISIT_NOTE'
export const SET_PATIENT_INSTRUCTION = 'chartsPage/SET_PATIENT_INSTRUCTION'

export const SET_ERROR = 'chartsPage/SET_ERROR'
export const DROP_ERROR = 'chartsPage/DROP_ERROR'

export const CLEAR_PATIENT_CHART = 'chartsPage/CLEAR_PATIENT_CHART'
export const CLEAR_ALERT_ADDED = 'chartPage/CLEAR_ALERT_ADDED'
export const CLEAR_PATIENT_LIST = 'chartsPage/CLEAR_PATIENT_LIST'
export const CLEAR_PATIENT_DATA = 'chartPage/CLEAR_PATIENT_DATA'
export const CLEAR_PAST_VISIT_INFO_DATA = 'chartPage/CLEAR_PAST_VISIT_INFO_DATA'
export const CLEAR_PATIENT_CHART_TREAT_LINK = 'chartsPage/SET_PATIENT_CHART_TREAT_LINK'

export const RESET_SEARCH_PHARMACY_LIST = 'chartsPage/RESET_SEARCH_PHARMACY_LIST'

export const SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED = 'chartsPage/SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED'
export const SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED =
  'chartsPage/SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED'

export const SAVE_VISIT_NOTES_ADDENDUM = 'chartsPage/SAVE_VISIT_NOTES_ADDENDUM'
export const SAVE_VISIT_NOTES_ADDENDUM_SUCCESS = 'chartsPage/SAVE_VISIT_NOTES_ADDENDUM_SUCCESS'
export const SAVE_VISIT_NOTES_ADDENDUM_ERROR = 'chartsPage/SAVE_VISIT_NOTES_ADDENDUM_ERROR'
export const SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS = 'chartsPage/SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS'
export const SAVE_PATIENT_INSTRUCTIONS_ADDENDUM = 'chartsPage/SAVE_PATIENT_INSTRUCTIONS_ADDENDUM'
export const SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR = 'chartsPage/SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR'
export const RESET_IS_ADDED_ALLERGY_STATUS = 'chartsPage/RESET_IS_ADDED_ALLERGY_STATUS'
export const RESET_IS_DELETED_ALLERGY_STATUS = 'chartsPage/RESET_IS_DELETED_ALLERGY_STATUS'
export const RESET_IS_VISIT_NOTE_SAVED_SUCCESS = 'chartsPage/RESET_IS_VISIT_NOTE_SAVED_SUCCESS'
export const RESET_IS_PATIENT_INSTRUCTION_SAVED_SUCCESS = 'chartsPage/RESET_IS_PATIENT_INSTRUCTION_SAVED_SUCCESS'

export const GET_MEDIA_FILES = 'chartPage/GET_MEDIA_FILES'
export const GET_MEDIA_FILES_SUCCESS = 'chartPage/GET_MEDIA_FILES_SUCCESS'
export const GET_MEDIA_FILES_ERROR = 'chartPage/GET_MEDIA_FILES_ERROR'

export const SET_MEDIA_FILE_TAGS = 'chartPage/SET_MEDIA_FILE_TAGS'
export const SET_MEDIA_FILE_TAGS_SUCCESS = 'chartPage/SET_MEDIA_FILE_TAGS_SUCCESS'
export const SET_MEDIA_FILE_TAGS_ERROR = 'chartPage/GET_MEDIA_FILES_ERROR'

export const ADD_MEDIA_FILE = 'chartPage/ADD_MEDIA_FILE'
export const ADD_MEDIA_FILE_SUCCESS = 'chartPage/ADD_MEDIA_FILE_SUCCESS'
export const ADD_MEDIA_FILE_ERROR = 'chartPage/ADD_MEDIA_FILE_ERROR'

export const SEARCH_FOR_ICD_CODES = 'chartPage/SEARCH_FOR_ICD_CODES'
export const SEARCH_FOR_ICD_CODES_ERROR = 'chartPage/SEARCH_FOR_ICD_CODES_ERROR'
export const SEARCH_FOR_ICD_CODES_SUCCESS = 'chartPage/SEARCH_FOR_ICD_CODES_SUCCESS'

export const UPDATE_ICD_CODES = 'chartPage/UPDATE_ICD_CODES'
export const UPDATE_ICD_CODES_SUCCESS = 'chartPage/UPDATE_ICD_CODES_SUCCESS'
export const UPDATE_ICD_CODES_ERROR = 'chartPage/UPDATE_ICD_CODES_ERROR'

export const SET_ICD_CODES_UPDATE_SUCCESS = 'chartPage/SET_ICD_CODES_UPDATE_SUCCESS'

export const SET_VISIT_PROVIDER = 'chartPage/SET_VISIT_PROVIDER'
export const SET_PAST_VISIT_PROVIDER = 'chartPage/SET_PAST_VISIT_PROVIDER'

export const SET_PATIENT_HAS_ALLERGIES = 'chartPage/SET_PATIENT_HAS_ALLERGIES'
export const SET_PATIENT_HAS_ALLERGIES_SUCCESS = 'chartPage/SET_PATIENT_HAS_ALLERGIES_SUCCESS'
export const SET_PATIENT_HAS_ALLERGIES_ERROR = 'chartPage/SET_PATIENT_HAS_ALLERGIES_ERROR'

export const SET_PATIENT_HAS_NO_ALLERGIES = 'chartPage/SET_PATIENT_HAS_NO_ALLERGIES'
export const SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS = 'chartPage/SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS'
export const SET_PATIENT_HAS_NO_ALLERGIES_ERROR = 'chartPage/SET_PATIENT_HAS_NO_ALLERGIES_ERROR'

export const DELETE_PATIENT_ALLERGY_FROM_STORAGE = 'chartPage/DELETE_PATIENT_ALLERGY_FROM_STORAGE'

export const GET_PATIENT_CREDIT_CARDS_SUCCESS = 'charts/GET_PATIENT_CREDIT_CARDS_SUCCESS'
export const GET_PATIENT_CREDIT_CARDS_ERROR = 'charts/GET_PATIENT_CREDIT_CARDS_ERROR'
